import { render, staticRenderFns } from "./SelectOptionHistory.vue?vue&type=template&id=2142c023&scoped=true"
import script from "./SelectOptionHistory.vue?vue&type=script&lang=js"
export * from "./SelectOptionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2142c023",
  null
  
)

export default component.exports